import { gql } from "@apollo/client";

export const GET_PROFESIONALES_ASIGNACION_PAGINATED = gql`
query GetProfesionalesParaRI(
    $idDelegacion: Int!
    $idTipoModulo: Int!
) {
    profesionalsForRIPaginated(
        idDelegacion: $idDelegacion, 
        idTipoModulo: $idTipoModulo
    ){
        idProfesional
        nombre
        apellido
        especialidad
        tipoProfesional
    }
}`;

export const adaptProfesional = (profesional) => {
  return {
    codigoProfesional: profesional?.idProfesional,
    nombre: profesional?.nombre,
    apellido: profesional?.apellido,
    tipoProfesional: profesional?.tipoProfesional,
    especialidad: profesional?.especialidad
  };
};

export const adaptProfesionalesArray = (
profesionales) =>
{
  return structuredClone(profesionales)?.
  map((profesional) => adaptProfesional(profesional));
};